import { useEffect, useState } from "react";

export const useServiceShareInputPagination = (currentPage: number, rowsPerPage: number) =>{
    const calculatedFirst = (currentPage * 10) - 10;

	const [first, setFirst] = useState<number>(calculatedFirst);
	const [rows, setRows] = useState<number>(rowsPerPage);

    useEffect(() => {
        setFirst(calculatedFirst);
    }, [currentPage])

    return {
        first,
        rows,
    }
}
